import KeyStrokeCounterPlugin from './plugin/KeyStrokeCounterPlugin';
import { LazyModule } from 'owa-bundling';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "KeyStrokeCounterPlugin" */ './lazyIndex')
);

export let LazyKeyStrokeCounterPluginClass = createLazyPlugin(
    lazyModule,
    m => m.KeyStrokeCounterPlugin,
    'KeyStrokeCounter'
);

export type LazyKeyStrokeCounterPlugin = LazyPlugin<KeyStrokeCounterPlugin>;
